import { Button } from '@/components/ui/button';
import ConfirmationDialog from '@/components/ui/dialog-wrapper/ConfirmationDialog';
import { toastSomethingError } from '@/components/ui/toast-content';

import PATH_PAGE from '@/router/path';
import { useDeleteWorkspace } from '@/service/workspace/hook';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

type DeleteWorkspaceProps = {
  workspaceId: string;
};

const DeleteWorkspace = (props: DeleteWorkspaceProps) => {
  const navigate = useNavigate();
  const { mutate } = useDeleteWorkspace({
    onSuccess: () => {
      toast.message('Workspace deleted');
      navigate(PATH_PAGE.setting.workspaces.root);
    },
    onError: () => {
      toastSomethingError();
    },
  });
  const handledDelete = async () => {
    mutate({
      workspace_id: props.workspaceId,
    });
  };

  return (
    <>
      <div className="flex flex-col md:flex-row md:justify-between">
        <div>
          <p className="font-medium">Delete this Workspace</p>
          <p className="mt-1">
            Once you delete a workspace, there is no going back. Please be
            certain.
          </p>
        </div>
        <div>
          <ConfirmationDialog
            title="Delete Workspace"
            message="Are you sure you want to delete this workspace?"
            onConfirm={handledDelete}
            confirmText="Delete"
            isCancel={false}
            slots={{
              confirmButton: {
                variant: 'destructive',
                className: 'w-full',
              },
            }}
          >
            <Button variant="destructive">Delete Workspace</Button>
          </ConfirmationDialog>
        </div>
      </div>
      {/* <ConfirmationDialog /> */}
    </>
  );
};
export default DeleteWorkspace;
